import { LucideFlame, LucideSearch } from "lucide-react";
import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/Button";
import { Typography } from "../ui/Typography";
import { Input } from "../ui/Input";
import { shuffled } from "../../lib/util";

export const SearchHero = (props: any) => {
    const [searching, setSearching] = useState(false);

    const onSearch = useCallback((query: string) => {
        if (searching) { return;}

        alert("GOED ZOEKEN BERTJE, WE ZOEKEN: " + query);
        setSearching(true);
    }, [searching]);

    const trendingTags: string[] = [
        "RPG", "UI", "Nootje", "Aapie", "Furniture", "Swords", "Medieval Armor", "Survival Gear",
        "Weapons", "Clothes", "Bert Vissers"
    ];

    const hot = ["Animals", "Fantasy RPG", "UI", "RPG"];

    return (
        <section className="relative overflow-hidden pt-24 pb-10 sm:pt-16 sm:pb-10 hero-bg-light dark:hero-bg-dark">
            <div className="mx-auto max-w-3xl px-   4 text-center">

                <Typography
                    as="h1"
                    variant="h1"
                >
                    Game <Accent>icons</Accent>.
                    <br />
                </Typography>

                <Typography
                    as="p"
                    variant="p"
                    className="text-lg mt-6"
                >
                    Discover professionally designed, game-ready icons.
                </Typography>

                <SearchInput
                    initialValue="UI Packs for survival game..."
                    placeholder="Search..."
                    onSearch={onSearch}
                />

                <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
                    {shuffled(trendingTags).map(tag => 
                        <TrendingTag 
                            key={tag} 
                            name={tag} 
                            onSearch={onSearch} 
                            isHot={hot.includes(tag)} 
                        />)}
                </div>
            </div>
        </section>
    );
};

interface TrendingTagProps {
    name: string;
    isHot: boolean;
    onSearch: (query: string) => void;
}

const TrendingTag = (props : any) => {
    const tagProps = props as TrendingTagProps;
    return (
        <button
            onClick={() => tagProps.onSearch(tagProps.name)}
            className={`text-surface-700 dark:text-surface-100 rounded-full border border-surface-200 transition-colors ` +
                "bg-surface-50 px-4 py-1 text-md select-none cursor-pointer inline-flex " +
                "justify-baseline items-center dark:border-surface-700 " +
                "dark:bg-surface-950 hover:border-brand-500 hover:text-surface-950 dark:hover:text-surface-50"}
        >
            {tagProps.isHot ? <LucideFlame size={18} className="mr-1 text-rose-500" fill="currentColor" /> : <></>}
            {tagProps.name}
        </button>
    );
};

const SearchInput = ({ initialValue, onSearch, searching = false, placeholder }: any) => {
    const [query, setQuery] = useState(initialValue || "");

    return (
        <div className="mt-10 max-w-2xl mx-auto flex flex-col sm:flex-row items-center gap-3">
            <div className="relative w-full">

                <LucideSearch className="absolute left-5 top-1/2 -translate-y-1/2 w-5 h-5 
                text-surface-300 dark:text-surface-400"/>

                <Input
                    intent="primary"
                    inputSize="large"
                    type="search"
                    value={query}
                    placeholder={placeholder}
                    onChange={ev => setQuery(ev.currentTarget.value)}
                    className="w-full h-14 "
                />

            </div>

            <Button
                disabled={searching}
                onClick={() => onSearch(query)}
                intent="primary"
                size="medium"
                className={"h-14"}
                hover={true}
            >
                <span className="text-lg">{searching ? null : "Search"}</span>
            </Button>
        </div>
    );
};

const Accent = ({ children, ...rest }: any) => (<span className="text-brand-500" {...rest}>{children}</span>);
